<!--Промежуток, который нужнен для возможности ре-рендеринга второй вкладке
после выбора другого года-->
<template>
  <region-page :key="activeYear" :guest = "guest" :active-year = "activeYear" :region="region" :municipality-name="municipalityName" :searched="searched"/>
</template>

<script>
import RegionPage from "@/components/region-page";

export default {
  name: "main-region-gap",
  props: {
    guest: Boolean,
    region: Number,
    activeYear: Number,
    municipalityName: String,
    searched: String
  },
  components: {RegionPage},
}
</script>

<style scoped>
</style>